// Shared constants for per-PR preview environments ({tenant}--pr-N.preview.valeriehealth.com).

export const PREVIEW_RETURN_COOKIE = "__preview_return";
export const ROOT_DOMAIN = "valeriehealth.com";

// Matches a full preview host for any tenant group, sandbox or real, e.g.
// entpartners-test--pr-123.preview.valeriehealth.com or stridecare--pr-456.preview.valeriehealth.com.
export const PREVIEW_HOST_PATTERN = /^[a-z0-9-]+--pr-\d+\.preview\.valeriehealth\.com$/;
